import { render, staticRenderFns } from "./AngelFalls.vue?vue&type=template&id=53583888&"
import script from "./AngelFalls.vue?vue&type=script&lang=js&"
export * from "./AngelFalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports